import { useDispatch, useSelector } from "react-redux";
import { slices } from "../redux";

export const useProfitOptions = () => {
    const dispatch = useDispatch();
    const options = useSelector((state) => state.profitOptions);

    return [options, (option) => dispatch(slices.profitOptions.actions.toggleOption(option))];
};
